import { render, staticRenderFns } from "./SheduleDocs.vue?vue&type=template&id=7ab12d6f&scoped=true&"
import script from "./SheduleDocs.vue?vue&type=script&lang=js&"
export * from "./SheduleDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab12d6f",
  null
  
)

export default component.exports